









































































































































































































import { Component } from "vue-property-decorator";
import PaginationComponent from "@/components/new_style_components/PaginationComponent.vue";
import PortalDate from "@/components/new_style_components/PortalDate.vue";
import PRILFilter from "@/dto/request/pril/PRILFilter";
import Application from "@/state/Application";
import PRILService from "@/services/request/PRILService";
import PRIL_DTO, {Direction} from "@/dto/request/pril/PRIL_DTO";
import { processError } from "@/utils/ComponentUtils";
import CreatePostalModal from "@/components/pril/CreatePostalModal.vue";
import DictionarySelect from "@/components/new_style_components/DictionarySelect.vue";
import { PRILStatus, PRILPriority } from "@/constants/request/PRILConstants";
import { prettyEnum } from "@/utils/StringUtils";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import SimpleCompanySearch from "@/components/new_style_components/SimpleCompanySearch.vue";
import SublimeSearch from "@/components/new_style_components/SublimeSearch.vue";
import { namespace } from "vuex-class";
import moment from "moment";
import RouteNames from "@/router/RouteNames";
import PRILExtension from "@/mixins/PRILExtension";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import AdminService from "@/services/AdminService";
import Auth from "@/state/Auth";
import { Role } from "@/constants/Role";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";

const AppModule = namespace("App");

@Component({
	components: {
		PortalCheckbox,
		SublimeSearch,
		DictionarySelect,
		PaginationComponent,
		PortalDate,
		PortalSelect,
		SimpleProfileSearch,
		SimpleCompanySearch,
	},
	computed: {
		PRILStatus() {
			return PRILStatus;
		},
		moment() {
			return moment
		}
	},
	methods: {
		prettyEnum
	}
})
export default class PostalList extends PRILExtension {
	@AppModule.State
	private isMobile!: boolean;

	private totalPages = 1;
	private countFilters = 0;
	private postalRegisterFilter = new PRILFilter();
	private postalList: Array<PRIL_DTO> = [];

	private selectedCustomer: ProfileDTO | null = null;
	private selectedSender: SublimeEmployeeDTO | null = null;
	private selectedAssignee: SublimeEmployeeDTO | null = null;

	mounted(): void {
		this.syncFiltersFromQuery();
		this.loadPostalList();
	}

	loadPostalList(): void {
		Application.startLoading();
		PRILService.getLettersByFilter(this.postalRegisterFilter).then(
			resp => {
				this.postalList = resp.data.content;
				this.totalPages = resp.data.totalPages;
				Application.stopLoading();
			},
			error => processError(error, this)
		).then(() => {
			this.applyRouteParams();
		});
	}

	private syncFiltersFromQuery(): void {
		const q = this.$route.query;
		if (Object.keys(q).length === 0) return;

		if (q.pageNumber) this.postalRegisterFilter.pageNumber = Number(q.pageNumber);
		if (q.letterDateFrom) this.postalRegisterFilter.letterDateFrom = q.letterDateFrom as any;
		if (q.letterDateTo) this.postalRegisterFilter.letterDateTo = q.letterDateTo as any;
		if (q.createDateFrom) this.postalRegisterFilter.createDateFrom = q.createDateFrom as any;
		if (q.createDateTo) this.postalRegisterFilter.createDateTo = q.createDateTo as any;
		if (q.customerId) this.postalRegisterFilter.customerId = Number(q.customerId);
		if (q.status) this.postalRegisterFilter.status = q.status as PRILStatus;
		if (q.sender) this.postalRegisterFilter.sender = Number(q.sender);
		if (q.assignee) this.postalRegisterFilter.assignee = Number(q.assignee);
		if (q.letterType) this.postalRegisterFilter.letterType = Number(q.letterType);
		if (q.priority) this.postalRegisterFilter.priority = q.priority as PRILPriority;
		if (q.phantom) this.postalRegisterFilter.phantom = q.phantom === 'true';
		if (q.archived) this.postalRegisterFilter.archived = q.archived === 'true';
		if (q.direction) this.postalRegisterFilter.direction = q.direction as Direction;

		if (this.postalRegisterFilter.sender) {
			AdminService.getEmployee(this.postalRegisterFilter.sender).then(resp => {
				this.selectedSender = resp.data;
			});
		}
		if (this.postalRegisterFilter.assignee) {
			AdminService.getEmployee(this.postalRegisterFilter.assignee).then(resp => {
				this.selectedAssignee = resp.data;
			});
		}

		this.updateCountFilters();
	}

	private updateCountFilters(): void {
		this.countFilters = 0;
		for (let key in this.postalRegisterFilter) {
			if (key !== 'pageNumber' && key !== 'pageSize') {
				if (this.postalRegisterFilter[key as keyof PRILFilter]) {
					this.countFilters += 1;
				}
			}
		}
	}

	private applyRouteParams(): void {
		const query: any = {};
		for (let key in this.postalRegisterFilter) {
			const val = this.postalRegisterFilter[key as keyof PRILFilter];
			if (val !== null && val !== undefined && (val as any) !== '' && val !== false) {
				if (key === 'pageSize') continue;
				if (key === 'pageNumber' && val === 1) continue;
				query[key] = String(val);
			}
		}
		this.$router.replace({ query }).catch(err => {
			if (err.name !== 'NavigationDuplicated') {
				throw err;
			}
		});
	}

	changePage(page: number): void {
		this.postalRegisterFilter.pageNumber = page;
		this.loadPostalList();
	}

	async resetFilters(): Promise<void> {
		this.postalRegisterFilter = new PRILFilter();
		this.selectedCustomer = null;
		this.selectedSender = null;
		this.selectedAssignee = null;
		this.updateCountFilters();
		await this.loadPostalList();
	}

	async confirmFilters(): Promise<void> {
		this.postalRegisterFilter.pageNumber = 1;
		this.updateCountFilters();
		await this.loadPostalList();
	}

	showCreatePostalModal(): void {
		this.$modal.show(CreatePostalModal,
			{
				callback: this.loadPostalList,
			},
			{
				width: this.isMobile ? 600 : 800,
			});
	}

	profileChanged(profile: ProfileDTO): void {
		this.selectedCustomer = profile;
		this.postalRegisterFilter.customerId = profile ? profile.id : null;
	}

	createdByChanged(createdBy: SublimeEmployeeDTO): void {
		this.selectedSender = createdBy;
		this.postalRegisterFilter.sender = createdBy ? createdBy.id : null;
	}

	assigneeChanged(assignee: SublimeEmployeeDTO): void {
		this.selectedAssignee = assignee;
		this.postalRegisterFilter.assignee = assignee ? assignee.id : null;
	}

	getStyleDueDate(date: Date): string {
		const expirationDate = new Date(date);
		const today = new Date();
		const nextWeek = new Date();
		nextWeek.setDate(nextWeek.getDate() + 7);

		if (expirationDate < today) {
			return 'text-danger fw-bold';
		} else if (expirationDate < nextWeek) {
			return 'text-warning fw-bold';
		} else {
			return '';
		}
	}

	goToPostalRecord(record: PRIL_DTO): void {
		if(record.status === PRILStatus.NEW && !Auth.hasPermission(Role.PRIL_MANAGER)) {
			return; // the user has no permission to perform initial processing
		}
		if (!Auth.hasPermission(Role.PRIL_EXECUTOR)) {
			return; // the user has no permission to process the record
		}
		this.$router.push({ name: RouteNames.PRIL, params: { id: `${record.id}` }});
	}
}
